// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"df8c047c2c38340a","5285":"ce23092692ea7fd3"}[chunkId] + ".css";
};